import script from "./SwiperProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperProjects.vue?vue&type=script&setup=true&lang=js"

import "./SwiperProjects.vue?vue&type=style&index=0&id=27beba28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27beba28"]])

export default __exports__